import Home from '@/components/pages/Home'
import MyServices from '@/components/pages/MyServices'
import MyOffices from '@/components/pages/MyOffices'
import Contact from '@/components/pages/Contact'
import PrivacyPolicy from '@/components/pages/PrivacyPolicy'
import TermsOfBusiness from '@/components/pages/TermsOfBusiness'
import WebsiteTermsAndConditions from '@/components/pages/WebsiteTermsAndConditions'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/my-services',
    name: 'MyServices',
    component: MyServices
  },
  {
    path: '/my-offices',
    name: 'MyOffices',
    component: MyOffices
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/terms-of-business',
    name: 'TermsOfBusiness',
    component: TermsOfBusiness
  },
  {
    path: '/website-terms-and-conditions',
    name: 'WebsiteTermsAndConditions',
    component: WebsiteTermsAndConditions
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js